import type {QueryClient} from "@tanstack/react-query";

import {endLocalSession} from "@/src/modules/auth/lib/end-local-session";

/**
 * After `POST shift/end`: officers (`tokens_revoked: true`) sign out on all devices;
 * Admin (`tokens_revoked: false`) keeps the bearer session and refreshes client state.
 */
export function finalizeShiftEndSession(
  tokensRevoked: boolean,
  queryClient?: QueryClient,
): void {
  if (tokensRevoked) {
    endLocalSession({reason: "shift_ended", source: "shift_end"});
    return;
  }

  if (queryClient) {
    void queryClient.invalidateQueries();
  }
}
